import script from "./SwordTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwordTag.vue?vue&type=script&setup=true&lang=ts"

import "./SwordTag.vue?vue&type=style&index=0&id=a358dd82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a358dd82"]])

export default __exports__